const TABLE_FILTER = {
  ACTIVE: "true",
  INACTIVE: "false",
};

export default TABLE_FILTER;
